import type { ComponentType } from "react";
import { Building2, FileSearch, Handshake, Hospital, Newspaper, ShieldCheck, Sparkles, UserRound, UsersRound } from "lucide-react";

export const navItems = [
  { label: "平台定位", href: "#positioning" },
  { label: "企业主页", href: "#enterprise" },
  { label: "找产品", href: "#resources" },
  { label: "资讯与洞察", href: "#content" },
  { label: "平台能力", href: "#capabilities" }
];

export const featureCards: Array<{
  eyebrow: string;
  title: string;
  description: string;
  icon: ComponentType<{ size?: number; strokeWidth?: number }>;
  tone: string;
}> = [
  {
    eyebrow: "产品资源",
    title: "找产品",
    description: "按品类、企业与准入信息检索药品、器械及其他行业资源。",
    icon: FileSearch,
    tone: "mint"
  },
  {
    eyebrow: "企业主页",
    title: "看厂商",
    description: "一页看清企业介绍、产品目录、招商信息、动态与联系人。",
    icon: Building2,
    tone: "blue"
  },
  {
    eyebrow: "招商协作",
    title: "找合作",
    description: "让招商需求、渠道与目标终端被更快看见，形成有效线索。",
    icon: Handshake,
    tone: "amber"
  },
  {
    eyebrow: "行业资讯",
    title: "读资讯",
    description: "及时了解政策、市场动态与行业通知，附件资料统一留存。",
    icon: Newspaper,
    tone: "lilac"
  }
];

export const capabilityCards = [
  {
    title: "可信连接",
    description: "认证、审核与可追溯关系，帮助用户在找到资源之后放心联系。",
    icon: ShieldCheck
  },
  {
    title: "个性化推荐",
    description: "从浏览、收藏、咨询等真实反馈出发，让推荐逐步更懂用户。",
    icon: Sparkles
  },
  {
    title: "行业协作",
    description: "把厂商、代理商、医药代表和终端资源放进同一条业务链路。",
    icon: UsersRound
  }
];

export const roleValueRows: Array<{
  role: string;
  provide: string;
  outcome: string;
  icon: ComponentType<{ size?: number; strokeWidth?: number }>;
  tone: string;
}> = [
  {
    role: "医药厂商",
    provide: "企业主页、产品目录、招商信息、企业动态",
    outcome: "让品牌与产品被准确看见，持续获得有效合作线索",
    icon: Building2,
    tone: "mint"
  },
  {
    role: "代理商 / 医药代表",
    provide: "产品、企业、招商搜索，名片与直接联系",
    outcome: "更快找到合适产品与合作方，建立可追踪关系",
    icon: Handshake,
    tone: "blue"
  },
  {
    role: "医疗机构与终端",
    provide: "可信产品信息、企业认证与供需对接",
    outcome: "减少无效沟通，更快对接真实、匹配的行业资源",
    icon: Hospital,
    tone: "amber"
  },
  {
    role: "行业用户",
    provide: "名片、收藏、分享、邀请与线索沉淀",
    outcome: "把一次查看变成下一步行动，让连接真正有回响",
    icon: UserRound,
    tone: "lilac"
  },
  {
    role: "平台运营",
    provide: "认证审核、内容管理、行为数据与推荐工具",
    outcome: "守住平台可信度，推动行业协作生态持续增长",
    icon: ShieldCheck,
    tone: "teal"
  }
];

export const structuredFacts = {
  name: "爱药事",
  alternateName: "行业114",
  operator: "四川爱药事科技有限公司",
  operatorStatement: "爱药事（行业114）是四川爱药事科技有限公司运营的医药行业资源撮合平台品牌；本网站为爱药事品牌官网。",
  description: "面向医药行业的资源撮合平台，连接产品、厂商、代理商、医疗机构与终端资源。",
  audiences: ["医药厂商", "代理商", "医药代表", "医疗机构与终端", "平台运营人员"]
};
